var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between"},[_c('h1',{staticClass:"page-header"},[_vm._v(_vm._s(_vm.$t('carAttendance.pageTitle')))]),_c('ts-breadcrumb',{attrs:{"items":[
        { text: _vm.$t('toHomePage'), href: '/' },
        {
          text: _vm.$t('carAttendance.pageTitle'),
          active: true
        }
      ]}})],1),_c('ts-card',[_c('ts-tabs',{attrs:{"target":"carAttendanceList"}},[_c('ts-tab',[_vm._v(_vm._s(_vm.$t('carAttendance.current')))]),_c('ts-tab',[_vm._v(_vm._s(_vm.$t('carAttendance.history')))])],1),_c('ts-tab-panes',{attrs:{"name":"carAttendanceList"}},[_c('ts-tab-pane',[_c('current')],1),_c('ts-tab-pane',[_c('history')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }